import React, { useState } from "react";
import { useSIP } from "../../hooks/calls/useSIP";
import { useSelector } from "react-redux";
import DialPad from "./DialPad";

const DialpadButton = () => {
  const modal = useSelector((state) => state?.modal?.modal);
  const [dialNumber, setDialNumber] = useState(modal?.data || "");

  const { dialCall } = useSIP();

  const handleDial = () => {
    dialCall(dialNumber);
  };

  return (
    <>
      <div>
        <DialPad dialNumber={dialNumber} setDialNumber={setDialNumber} handleDial={handleDial} />
      </div>
    </>
  );
};

export default DialpadButton;
